export const COUNTRY_ATTR = 'region'
export const CACHE_ATTRS  = ['region', 'sr', 'name']

export const SCALE_SLOTS = 5
export const REGION_API_KEYS = {
  'Nordjylland':        'nordjylland',
  'Midtjylland':        'midtjylland',
  'Syddanmark':         'syddanmark',
  'Region Østdanmark':  'oestdanmark',
}

export const COUNTRY_LABEL_FALLBACK = 'Hele Danmark'

export const SR_LABEL_PREFIX = 'Sundhedsråd'
export const ENTITY_LABEL_OVERRIDES = {
  'SR Københavns omegn Nord': 'Sundhedsråd Københavns Omegn Nord',
  'SR Østsjælland og øerne':  'Sundhedsråd Østsjælland og Øerne',
}

export const FULL_VIEWBOX = { x: 1262, y: 1258.52, w: 3510, h: 3527.71 }
export const ZOOM_PAD     = 80
export const ZOOM_DUR     = 380

export const prefersReducedMotion = () =>
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false
